import { renderLocationSidebar } from './locationSidebar';

export const ROUTES_TEMPLATE = `
<div class="flex h-screen overflow-hidden bg-background-light">
${renderLocationSidebar('routes')}
<main class="ml-64 flex-1 overflow-hidden flex flex-col">
  <div class="flex-1 overflow-auto p-8">
    <div class="flex items-end justify-between mb-8">
      <div>
        <h1 class="text-3xl font-black text-slate-900 tracking-tight">Routes</h1>
        <p class="mt-1 text-sm text-slate-500">Manage route catalog, moderation workflow, and publication</p>
      </div>
      <button id="routes-create-btn" class="inline-flex items-center gap-2 h-11 px-6 rounded-lg bg-primary text-white font-bold shadow-sm shadow-primary/20 hover:bg-primary/90 transition-colors" type="button">
        <span class="material-symbols-outlined text-[20px]">add</span>
        <span>Create Route</span>
      </button>
    </div>

    <section class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-5 mb-8">
      <article class="bg-white border border-slate-200 rounded-xl p-5 shadow-sm text-center">
        <p class="text-sm text-slate-500 font-medium">Published</p>
        <p id="routes-kpi-published" class="mt-1 text-3xl font-black text-slate-900">0</p>
      </article>
      <article class="bg-white border border-slate-200 rounded-xl p-5 shadow-sm text-center">
        <p class="text-sm text-slate-500 font-medium">Pending Review</p>
        <p id="routes-kpi-pending" class="mt-1 text-3xl font-black text-slate-900">0</p>
      </article>
      <article class="bg-white border border-slate-200 rounded-xl p-5 shadow-sm text-center">
        <p class="text-sm text-slate-500 font-medium">Draft</p>
        <p id="routes-kpi-draft" class="mt-1 text-3xl font-black text-slate-900">0</p>
      </article>
      <article class="bg-white border border-slate-200 rounded-xl p-5 shadow-sm text-center">
        <p class="text-sm text-slate-500 font-medium">Featured</p>
        <p id="routes-kpi-featured" class="mt-1 text-3xl font-black text-slate-900">0</p>
      </article>
    </section>

    <section class="bg-white rounded-xl border border-slate-200 shadow-sm overflow-hidden">
      <div class="p-4 border-b border-slate-100 flex flex-wrap gap-3 items-center">
        <div class="relative flex-1 min-w-[260px]">
          <span class="material-symbols-outlined absolute left-3 top-1/2 -translate-y-1/2 text-slate-400">search</span>
          <input id="routes-search-input" class="w-full h-10 pl-10 pr-4 rounded-lg bg-slate-50 border border-slate-200 text-sm placeholder:text-slate-400 focus:border-primary focus:ring-primary" placeholder="Search by title, slug, or location..." type="text"/>
        </div>
        <select id="routes-status-filter" class="h-10 px-3 rounded-lg border border-slate-200 bg-slate-50 text-sm text-slate-700 focus:border-primary focus:ring-primary">
          <option value="all">Status: All</option>
          <option value="published">Published</option>
          <option value="pending_review">Pending Review</option>
          <option value="approved">Approved</option>
          <option value="rejected">Rejected</option>
          <option value="draft">Draft</option>
          <option value="archived">Archived</option>
        </select>
        <select id="routes-featured-filter" class="h-10 px-3 rounded-lg border border-slate-200 bg-slate-50 text-sm text-slate-700 focus:border-primary focus:ring-primary">
          <option value="all">Featured: All</option>
          <option value="true">Featured: Yes</option>
          <option value="false">Featured: No</option>
        </select>
        <select id="routes-category-filter" class="h-10 px-3 rounded-lg border border-slate-200 bg-slate-50 text-sm text-slate-700 focus:border-primary focus:ring-primary">
          <option value="">Category: All</option>
        </select>
        <select id="routes-ordering-filter" class="h-10 px-3 rounded-lg border border-slate-200 bg-slate-50 text-sm text-slate-700 focus:border-primary focus:ring-primary">
          <option value="-created_at">Created (Newest)</option>
          <option value="title">Title (A-Z)</option>
          <option value="-distance_km">Distance (High-Low)</option>
          <option value="-favorites_count">Popular</option>
        </select>
      </div>

      <div class="px-4 pb-4 border-b border-slate-100 flex flex-wrap gap-3 items-center">
        <input id="routes-distance-min-filter" class="h-9 px-3 rounded-lg bg-slate-50 border border-slate-200 text-[13px] w-28" placeholder="Dist min" type="number"/>
        <input id="routes-distance-max-filter" class="h-9 px-3 rounded-lg bg-slate-50 border border-slate-200 text-[13px] w-28" placeholder="Dist max" type="number"/>
        <input id="routes-duration-min-filter" class="h-9 px-3 rounded-lg bg-slate-50 border border-slate-200 text-[13px] w-28" placeholder="Dur min" type="number"/>
        <input id="routes-duration-max-filter" class="h-9 px-3 rounded-lg bg-slate-50 border border-slate-200 text-[13px] w-28" placeholder="Dur max" type="number"/>
        <input id="routes-elevation-min-filter" class="h-9 px-3 rounded-lg bg-slate-50 border border-slate-200 text-[13px] w-28" placeholder="Elev min" type="number"/>
        <input id="routes-elevation-max-filter" class="h-9 px-3 rounded-lg bg-slate-50 border border-slate-200 text-[13px] w-28" placeholder="Elev max" type="number"/>
        <button id="routes-reset-filters-btn" class="h-9 px-3 rounded-lg border border-slate-200 text-[13px] font-semibold text-primary hover:bg-primary/5" type="button">Reset</button>
      </div>

      <div class="px-4 py-2 border-b border-slate-100 text-xs text-slate-500 font-medium">
        <span id="routes-results-meta-inline">Showing 0 of 0 routes</span>
      </div>

      <div class="overflow-x-auto">
        <table class="w-full text-left border-collapse min-w-[1220px]">
          <thead>
            <tr class="bg-slate-50 border-b border-slate-200">
              <th class="py-4 px-4 text-[11px] font-bold text-slate-500 uppercase tracking-wider w-16">ID</th>
              <th class="py-4 px-4 text-[11px] font-bold text-slate-500 uppercase tracking-wider min-w-[260px]">Title & Slug</th>
              <th class="py-4 px-4 text-[11px] font-bold text-slate-500 uppercase tracking-wider">Location</th>
              <th class="py-4 px-4 text-[11px] font-bold text-slate-500 uppercase tracking-wider">Status</th>
              <th class="py-4 px-4 text-[11px] font-bold text-slate-500 uppercase tracking-wider text-center">Featured</th>
              <th class="py-4 px-4 text-[11px] font-bold text-slate-500 uppercase tracking-wider">Distance</th>
              <th class="py-4 px-4 text-[11px] font-bold text-slate-500 uppercase tracking-wider">Duration</th>
              <th class="py-4 px-4 text-[11px] font-bold text-slate-500 uppercase tracking-wider">Elevation (G/L)</th>
              <th class="py-4 px-4 text-[11px] font-bold text-slate-500 uppercase tracking-wider text-center">Wpts</th>
              <th class="py-4 px-4 text-[11px] font-bold text-slate-500 uppercase tracking-wider text-center">Favs</th>
              <th class="py-4 px-4 text-[11px] font-bold text-slate-500 uppercase tracking-wider">Source</th>
              <th class="py-4 px-4 text-[11px] font-bold text-slate-500 uppercase tracking-wider">Created At</th>
              <th class="py-4 px-4 text-[11px] font-bold text-slate-500 uppercase tracking-wider">Updated At</th>
              <th class="py-4 px-4 text-[11px] font-bold text-slate-500 uppercase tracking-wider text-right sticky right-0 bg-slate-50 z-10">Actions</th>
            </tr>
          </thead>
          <tbody id="routes-table-body" class="divide-y divide-slate-100">
            <tr>
              <td class="px-4 py-8 text-slate-500 text-sm" colspan="15">Loading routes...</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="border-t border-slate-100 px-4 py-3 flex items-center justify-between gap-4">
        <p id="routes-results-meta" class="text-xs text-slate-500 font-medium">Showing 0 routes</p>
        <div class="flex items-center gap-2">
          <button id="routes-prev-btn" class="px-3 py-1.5 rounded-lg border border-slate-200 text-slate-600 hover:bg-white text-sm disabled:opacity-50 disabled:cursor-not-allowed" type="button">Prev</button>
          <span id="routes-page-indicator" class="text-xs font-semibold text-slate-500 min-w-[72px] text-center">Page 1</span>
          <button id="routes-next-btn" class="px-3 py-1.5 rounded-lg border border-slate-200 text-slate-600 hover:bg-white text-sm disabled:opacity-50 disabled:cursor-not-allowed" type="button">Next</button>
        </div>
      </div>
    </section>
  </div>
</main>
</div>

<div id="routes-view-overlay" class="fixed inset-0 z-[70] hidden">
  <div id="routes-view-backdrop" class="absolute inset-0 bg-slate-900/40 backdrop-blur-sm"></div>
  <aside class="absolute right-0 top-0 h-full w-full md:w-1/2 bg-white shadow-2xl border-l border-slate-200 flex flex-col">
    <div class="flex items-start justify-between p-6 border-b border-slate-100">
      <div class="flex-1">
        <h2 id="routes-view-title" class="text-2xl font-black text-slate-900">Route</h2>
        <div class="flex items-center gap-3 mt-2 flex-wrap">
          <p id="routes-view-subtitle" class="text-xs text-slate-500">ID: -</p>
          <p class="text-xs text-slate-400">slug:</p>
          <p id="routes-view-slug" class="text-xs font-mono bg-slate-100 text-slate-600 px-2 py-0.5 rounded break-all">-</p>
        </div>
      </div>
      <button id="routes-view-close-btn" class="p-2 rounded-full text-slate-400 hover:text-slate-700 hover:bg-slate-100" type="button">
        <span class="material-symbols-outlined">close</span>
      </button>
    </div>
    <div class="flex-1 overflow-y-auto p-6 space-y-6">
      <div id="routes-view-error" class="hidden rounded-lg border border-rose-200 bg-rose-50 px-3 py-2 text-sm text-rose-700"></div>

      <div class="h-56 rounded-xl overflow-hidden border border-slate-200 bg-slate-100">
        <img id="routes-view-hero" class="w-full h-full object-cover" alt="Route cover" src=""/>
      </div>
      <div id="routes-view-gallery" class="grid grid-cols-4 gap-2"></div>

      <div class="flex flex-wrap items-center gap-2">
        <span id="routes-view-status" class="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-[10px] font-bold uppercase bg-slate-100 text-slate-700">Draft</span>
        <span id="routes-view-source" class="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-[10px] font-bold uppercase bg-primary/10 text-primary">Editor</span>
        <span id="routes-view-featured" class="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-[10px] font-bold uppercase bg-amber-100 text-amber-700">Not Featured</span>
        <span id="routes-view-content-format" class="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-[10px] font-bold uppercase bg-slate-100 text-slate-700">blocks_v1</span>
        <span id="routes-view-is-favorited" class="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-[10px] font-bold uppercase bg-slate-100 text-slate-700">Not Favorited</span>
      </div>

      <div class="grid grid-cols-2 gap-4">
        <div class="p-4 rounded-xl border border-slate-100 bg-slate-50/70">
          <p class="text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-2">Route Dates</p>
          <div class="space-y-1 text-xs text-slate-600">
            <div class="flex items-center gap-2"><span class="material-symbols-outlined text-sm text-slate-400">calendar_add_on</span><span id="routes-view-created-at">-</span></div>
            <div class="flex items-center gap-2"><span class="material-symbols-outlined text-sm text-slate-400">edit_calendar</span><span id="routes-view-updated-at">-</span></div>
            <div class="flex items-center gap-2"><span class="material-symbols-outlined text-sm text-slate-400">event_available</span><span id="routes-view-published-at">-</span></div>
          </div>
        </div>
        <div class="p-4 rounded-xl border border-slate-100 bg-slate-50/70">
          <p class="text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-1">Review Comment</p>
          <p id="routes-view-review-comment" class="text-xs text-slate-600 italic">-</p>
          <p class="text-[10px] font-bold text-slate-400 uppercase tracking-widest mt-4 mb-1">Reviewed At</p>
          <p id="routes-view-reviewed-at" class="text-xs text-slate-600">-</p>
        </div>
      </div>

      <section>
        <div class="mb-3 flex items-center justify-between">
          <h3 class="text-sm font-bold text-slate-900">Reviews</h3>
          <p id="routes-view-reviews-count" class="text-xs text-slate-500">0</p>
        </div>
        <div id="routes-view-reviews" class="space-y-2"></div>
      </section>

      <section>
        <h3 class="text-sm font-bold text-slate-900 mb-3 flex items-center gap-2">
          <span class="material-symbols-outlined text-primary text-lg">analytics</span>
          Route Statistics
        </h3>
        <div class="grid grid-cols-3 gap-3">
          <div class="bg-white border border-slate-100 p-3 rounded-xl shadow-sm">
            <p class="text-[10px] font-medium text-slate-400 uppercase">Distance</p>
            <p id="routes-view-distance" class="text-lg font-bold text-slate-900">-</p>
          </div>
          <div class="bg-white border border-slate-100 p-3 rounded-xl shadow-sm">
            <p class="text-[10px] font-medium text-slate-400 uppercase">Duration</p>
            <p id="routes-view-duration" class="text-lg font-bold text-slate-900">-</p>
          </div>
          <div class="bg-white border border-slate-100 p-3 rounded-xl shadow-sm">
            <p class="text-[10px] font-medium text-slate-400 uppercase">Waypoints</p>
            <p id="routes-view-waypoints-count" class="text-lg font-bold text-slate-900">0</p>
          </div>
          <div class="bg-white border border-slate-100 p-3 rounded-xl shadow-sm">
            <p class="text-[10px] font-medium text-slate-400 uppercase">Elev. Gain</p>
            <p id="routes-view-elevation-gain" class="text-lg font-bold text-emerald-600">-</p>
          </div>
          <div class="bg-white border border-slate-100 p-3 rounded-xl shadow-sm">
            <p class="text-[10px] font-medium text-slate-400 uppercase">Elev. Loss</p>
            <p id="routes-view-elevation-loss" class="text-lg font-bold text-rose-600">-</p>
          </div>
          <div class="bg-white border border-slate-100 p-3 rounded-xl shadow-sm">
            <p class="text-[10px] font-medium text-slate-400 uppercase">Favorites</p>
            <p id="routes-view-favorites" class="text-lg font-bold text-slate-900">0</p>
          </div>
        </div>
      </section>

      <section>
        <h3 class="text-sm font-bold text-slate-900 mb-2">Location</h3>
        <p id="routes-view-location-name" class="text-sm text-slate-700">-</p>
      </section>

      <section>
        <div class="mb-4">
          <h3 class="text-sm font-bold text-slate-900 mb-2">Categories</h3>
          <div id="routes-view-categories" class="flex flex-wrap gap-2">
            <span class="px-3 py-1 bg-slate-100 text-slate-600 text-xs font-semibold rounded-full">-</span>
          </div>
        </div>
        <div>
          <h3 class="text-sm font-bold text-slate-900 mb-2">Tags</h3>
          <div id="routes-view-tags" class="flex flex-wrap gap-2">
            <span class="px-2 py-1 border border-slate-200 text-slate-500 text-xs rounded-lg font-medium">-</span>
          </div>
        </div>
      </section>

      <section>
        <h3 class="text-sm font-bold text-slate-900 mb-3 flex items-center gap-2">
          <span class="material-symbols-outlined text-primary text-lg">route</span>
          Route Path
        </h3>
        <div class="grid grid-cols-2 gap-3 text-sm mb-3">
          <div><p class="text-xs text-slate-500 uppercase">Start</p><p id="routes-view-start-coords" class="font-medium text-primary">-</p></div>
          <div><p class="text-xs text-slate-500 uppercase">Finish</p><p id="routes-view-end-coords" class="font-medium text-primary">-</p></div>
        </div>
        <div id="routes-view-waypoints" class="space-y-2"></div>
      </section>

      <section>
        <h3 class="text-sm font-bold text-slate-900 mb-2">Description</h3>
        <div id="routes-view-description" class="bg-slate-50 border border-slate-100 rounded-xl p-4 text-xs text-slate-600 leading-relaxed whitespace-pre-wrap">-</div>
      </section>

      <section>
        <h3 class="text-sm font-bold text-slate-900 mb-2">Structured Content (blocks_v1)</h3>
        <div id="routes-view-content-preview" class="bg-slate-50 border border-slate-100 rounded-xl p-4 text-xs text-slate-700 leading-relaxed overflow-x-auto">-</div>
        <details class="mt-3">
          <summary class="cursor-pointer text-xs font-semibold text-slate-500">Raw JSON</summary>
          <pre id="routes-view-content-json" class="mt-2 bg-slate-900 text-slate-100 rounded-lg p-3 text-[11px] leading-relaxed overflow-x-auto whitespace-pre-wrap">[]</pre>
        </details>
      </section>
    </div>

    <div class="p-6 border-t border-slate-100 bg-white grid grid-cols-2 gap-3">
      <div class="flex flex-col gap-2">
        <button id="routes-view-edit-btn" class="w-full py-2.5 px-3 border border-slate-200 text-slate-700 rounded-lg text-xs font-bold hover:bg-slate-50" type="button">Edit</button>
        <button id="routes-view-delete-btn" class="w-full py-2.5 px-3 border border-rose-100 text-rose-600 rounded-lg text-xs font-bold hover:bg-rose-50" type="button">Delete Route</button>
      </div>
      <div class="flex flex-col gap-2">
        <button id="routes-view-publish-btn" class="w-full py-2.5 px-3 bg-primary text-white rounded-lg text-xs font-bold hover:bg-primary/90" type="button">Publish to Community</button>
      </div>
    </div>
  </aside>
</div>
`;
